export const formatFloat = (num) => {
	return parseFloat(num)
		.toFixed(2)
		.replace(/\d(?=(\d{3})+\.)/g, '$&,');
};
